export const headerData = [
    { buttonText: "ЛИЧНЫЙ КАБИНЕТ", buttonLink: "/ucp" },
    { buttonText: "МАГАЗИН", buttonLink: "/ucp/shop/?category=main" },
    { buttonText: "НАЗАД", buttonLink: "/ucp/shop?category=main"},
];
